import { render, staticRenderFns } from "./CO2Icon.vue?vue&type=template&id=9306a514&scoped=true&"
import script from "./CO2Icon.vue?vue&type=script&lang=js&"
export * from "./CO2Icon.vue?vue&type=script&lang=js&"
import style0 from "./CO2Icon.vue?vue&type=style&index=0&id=9306a514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9306a514",
  null
  
)

export default component.exports